export const FLATS = "/api/flats";
export const CARS = "/api/cars";
export const BATHS = "/api/baths";
export const COTTAGES = "/api/cottages";
export const NEWS = "/api/news";
export const NAVIGATION = "/api/navigation";
export const DROPDOWN = "/api/menu";
